const DEFAULT_CHARTJS_STYLE = 'line';
const DEFAULT_SMOOTHING = 'linear';
const DEFAULT_SYMBOL = 'circle';
const DEFAULT_CURVE = {
    type: 'linear',
    curve: 'curveLinear',
    allowed: true,
};

export { DEFAULT_CHARTJS_STYLE, DEFAULT_SMOOTHING, DEFAULT_SYMBOL, DEFAULT_CURVE };
